import React from "react";
import "../../../css/WhyThisMatters.css";
import SecondaryButton from "../../designSystem/SecondaryButton";
import { HashLink } from "react-router-hash-link";
import { useLocation } from "react-router-dom";

const WhyThisMatters = () => {
  const location = useLocation();
  const isSchoolPage = location.pathname === "/for-schools";
  return (
    <section className="why-matters-section">
      <div className="why-choose-us__container">
        <h4>WHY THIS MATTERS NOW</h4>
        <div className="divider" />
        <div className="why-matters-box">
          <div className="why-matters-stat">
            <h1 className="accent">£15.8m</h1>
            <div className="content">
              in school fees protected through death claims alone over the last
              decade, by a single provider
            </div>
          </div>
          <div className="why-matters-stat">
            <h1 className="accent">400+</h1>
            <div className="content">
              independent schools relied on that provider, a market leader since
              1991, who has now withdrawn from the market
            </div>
          </div>
          <div className="why-matters-stat">
            <h1 className="accent">0</h1>

            <div className="content">
              comparable providers replaced them. Until now. For the first time
              in over 30 years, there is a gap in this market and we are here to
              fill it.
            </div>
          </div>
        </div>
        <div className="help-text-regular align-center">
          Source:{" "}
          <a
            href="https://www.sfs-group.co.uk/about-us/our-team/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
            // rel="noopener noreferrer"
            // className="content accent"
          >
            Endsleigh School Fees Insurance (SFS Group Ltd)
          </a>
          ,{" "}
          <a
            href="https://www.sfs-group.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline" }}
          >
            www.sfs-group.co.uk
          </a>
        </div>
        <div className="why-matters-newsletter">
          <span className="subtitle-medium">
            Sign up to our monthly newsletter to see the latest ways to protect
            your child’s education.
          </span>
          <br />
        </div>
        <div className="align-center">
          <HashLink
            smooth
            to={isSchoolPage ? "/for-schools#contact" : "/#contact"}
            style={{ textDecoration: "none" }}
          >
            <SecondaryButton>
              <div className="button-text primary">SIGN UP NOW</div>
            </SecondaryButton>
          </HashLink>
        </div>
      </div>
    </section>
  );
};

export default WhyThisMatters;
